import script from "./Formulaire.vue?vue&type=script&setup=true&lang=js"
export * from "./Formulaire.vue?vue&type=script&setup=true&lang=js"

import "./Formulaire.vue?vue&type=style&index=0&id=bd1b153c&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd1b153c"]])

export default __exports__